var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentProcessing64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.2,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.01.5l1.427.09A7 7 0 0124 7.576V15a1 1 0 001 1h7.451a7 7 0 016.985 6.534l.02.3.044-.431V46.5a5 5 0 01-5 5h-29a5 5 0 01-5-5v-41a5 5 0 015-5h10.51zm10.948 3.756l9.57 9.458a9.997 9.997 0 011.512 1.911L26.958 4.256z",
    fill: "url(#a)",
    transform: "translate(12 6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 27.5v-17a4 4 0 014-4h14.549a10 10 0 017.029 2.887l10.986 10.856a8.2 8.2 0 012.436 5.832V27.5m0 9v5m0 9v3a4 4 0 01-4 4h-3m-9 0h-7m-9 0h-3a4 4 0 01-4-4v-3m0-9v-5",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.46 25.918a7.005 7.005 0 00-6.233-4.41l-.274-.005h-7.451a1 1 0 01-.994-.884l-.006-.116v-7.424A7.003 7.003 0 0032.03 6.55",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentProcessing64);
export default __webpack_public_path__ + "static/media/document-processing-64.efced3c1.svg";
export { ForwardRef as ReactComponent };